import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocal',
})
export class UtcToLocalPipe implements PipeTransform {
  transform(value: string): string {
    if (!value || value==='') return '';
    // const date = new Date(value.replace(' ', 'T') + 'Z');
    const date = new Date(value + ' UTC');
    // return date.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour12: true, hour: '2-digit', minute: '2-digit' });
  }
}
